<div class="card rounded border mb-lg-0 mb-3">
  <div *ngIf="member$ | async as member">
    <div class="">
      <label class="mb-0 text-black">{{ 'account.details.dob' | translate }}</label>
      <div class="d-flex bg-muted p-2 m-0 mt-1 rounded">
        <span class="icon material-icons text-black">date_range</span>
        <span class="ms-3 font-size-12 text-black">{{ member.DOB | date : 'MMM d, yyy' }}</span>
      </div>
    </div>
    <div>
      <label class="mb-0 personal-info text-black">{{ 'account.details.email' | translate }}</label>
      <div class="d-flex bg-muted p-2 m-0 mt-1 rounded">
        <span class="icon material-icons text-black">mail</span>
        <span class="ms-3 font-size-12 text-black">{{ member.EmailAddress1 }}</span>
      </div>
    </div>
  </div>
</div>

<ng-template #loadingRef>
  <fgb-loading></fgb-loading>
</ng-template>
